module.exports = __webpack_public_path__ + "img/frame (283).4898ff75.jpg";